import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Stack,
  Divider,
  IconButton,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { company, footerLinks } from "../../data/siteContent";
import PrimaryButton from "../ui/PrimaryButton";

export default function Footer() {
  const year = new Date().getFullYear();

  const linkColumn = (title, items) => (
    <Box>
      <Typography variant="subtitle1" fontWeight={700} gutterBottom color="primary.light">
        {title}
      </Typography>
      <Stack spacing={1}>
        {items.map((item) => (
          <Link
            key={item.title}
            component={RouterLink}
            to={item.link}
            underline="hover"
            color="rgba(255,255,255,0.85)"
            variant="body2"
            sx={{
              display: "inline-block",
              "&:hover": { color: "#fff" },
            }}
          >
            {item.title}
          </Link>
        ))}
      </Stack>
    </Box>
  );

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#0c1528",
        color: "#fff",
        pt: { xs: 6, md: 8 },
        pb: 3,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}${company.logos.icon}`}
              alt=""
              sx={{ height: 48, width: "auto", mb: 1.5 }}
            />
            <Typography variant="h6" fontWeight={700} gutterBottom>
              {company.name}
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.65)", mb: 1, fontStyle: "italic" }}>
              {company.tagline}
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.75)", mb: 2 }}>
              {company.description}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                href={company.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "#fff", bgcolor: "rgba(255,255,255,0.08)" }}
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                href={company.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "#fff", bgcolor: "rgba(255,255,255,0.08)" }}
                aria-label="Facebook"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href={`mailto:${company.email}`}
                sx={{ color: "#fff", bgcolor: "rgba(255,255,255,0.08)" }}
                aria-label="Email"
              >
                <EmailOutlinedIcon />
              </IconButton>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            {linkColumn("Services", footerLinks.services.slice(0, 5))}
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            {linkColumn("Company", footerLinks.company)}
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom color="primary.light">
              Get in touch
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.75)", mb: 0.5 }}>
              {company.address}
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.75)", mb: 0.5 }}>
              {company.phone}
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.75)", mb: 2 }}>
              {company.email}
            </Typography>
            <PrimaryButton to="/contact" color="secondary">
              Contact us
            </PrimaryButton>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.12)", my: 4 }} />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.6)" }}>
            {`\u00A9 ${year} ${company.name}. All rights reserved.`}
          </Typography>
          <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center">
            {footerLinks.legal.map((item) => (
              <Link
                key={item.link}
                component={RouterLink}
                to={item.link}
                variant="body2"
                underline="hover"
                color="rgba(255,255,255,0.6)"
                sx={{ "&:hover": { color: "#fff" } }}
              >
                {item.title}
              </Link>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
